import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { FormikInput, Button } from '../../UI';
import { NewTealiumIntegrationFormSchema } from '../../../schemas';
import { useUserContext } from '../../../contexts/UserContext';
import { addNewTealiumProduct } from '../../../utils/APIs';
import Loader from '../../UI/Loader/Loader';
import { useNavigate } from 'react-router-dom';
import backwardArrow from '../../../assets/icons/backward-arrow.svg';
import { toast } from 'react-toastify';
import { useContentfulContext } from '../../../contexts/ContentfulContext';
import { Eye, EyeOff } from 'lucide-react';

const NewTealiumIntegration = () => {
  const { userData, updateTealiumIntegrations, updateDefaultTealiumKey } = useUserContext();
  const { content } = useContentfulContext();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showTealiumKey, setShowTealiumKey] = useState(false);

  const handleSubmit = async (values, actions) => {
    try {
      setLoading(true);

      const data = {
        tealium_api_name: values.tealium_api_name,
        tealium_account: values.tealium_account,
        tealium_profile: values.tealium_profile,
        tealium_user: values.tealium_user,
        tealium_key: values.tealium_key,
      };


      const result = await addNewTealiumProduct(userData.token, {
        organizationId: userData.selectedOrganization.org_token,
        data,
      });
     !loading && toast.success(content.NEW_TEALIUM_INTEGRATION_CONTENT.success);
      updateTealiumIntegrations()
      if(!userData.defaultTealiumKey) {
        updateDefaultTealiumKey(result.data)
      }
      setTimeout(() => {
        navigate('/setup/tealium-api-key-integrations');
      }, 1000);
    } catch (error) {
      toast.error(error?.message || "default error");
    } finally {
      setLoading(false);
    }
  };

  
  return (
    <div className="w-full px-4 md:px-8 my-6">
      {loading && <Loader />}
      <div className="w-full lg:w-1/2 space-y-4 md:space-y-6">
          <p className="font-medium cursor-pointer text-primary hover:underline flex items-center" onClick={(e) => {
            e.preventDefault();
            navigate('/setup/tealium-api-key-integrations')
          }}>
            <img src={backwardArrow} alt='' className='w-5 h-5 mr-2' /> {content.NEW_TEALIUM_INTEGRATION_CONTENT.back_cta_text} 
          </p>
          <Formik
            initialValues={{
              tealium_account: "",
              tealium_api_name: "",
              tealium_key: "",
              tealium_profile: "",
              tealium_user: "",
              organization_name: ""
            }}
            validationSchema={() => NewTealiumIntegrationFormSchema(content.NEW_TEALIUM_INTEGRATION_CONTENT)}
            onSubmit={handleSubmit}
          >
            {() => (
              <Form action="#" className="space-y-4">
                <h2 className="text-xl font-bold leading-tight tracking-tight text-black text-left mb-4">{content.NEW_TEALIUM_INTEGRATION_CONTENT.title}</h2>
                <p>{content.NEW_TEALIUM_INTEGRATION_CONTENT.description}</p>
                <FormikInput
                  type="text"
                  id="tealium_api_name"
                  name="tealium_api_name"
                  label={content.NEW_TEALIUM_INTEGRATION_CONTENT.formLabels.tealium_api_name}
                  helperText={content.NEW_TEALIUM_INTEGRATION_CONTENT.help_text.tealium_api_name}
                />
                <FormikInput
                  type="text"
                  id="tealium_account"
                  name="tealium_account"
                  label={content.NEW_TEALIUM_INTEGRATION_CONTENT.formLabels.tealium_account}
                  helperText={content.NEW_TEALIUM_INTEGRATION_CONTENT.help_text.tealium_account}
                />
                <FormikInput
                  type={showTealiumKey ? "text" : "password"}
                  id="tealium_key"
                  name="tealium_key"
                  label={content.NEW_TEALIUM_INTEGRATION_CONTENT.formLabels.tealium_key}
                  helperText={content.NEW_TEALIUM_INTEGRATION_CONTENT.help_text.tealium_key}
                  suffixIcon={
                    <button
                      type="button"
                      onClick={() => setShowTealiumKey(prev => !prev)}
                      className="text-gray-400 hover:text-gray-600 focus:outline-none"
                      aria-label={showTealiumKey ? "Hide Tealium key" : "Show Tealium key"}
                    >
                      {showTealiumKey ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  }
                />
                <FormikInput
                  type="text"
                  id="tealium_profile"
                  name="tealium_profile"
                  label={content.NEW_TEALIUM_INTEGRATION_CONTENT.formLabels.tealium_profile}
                  helperText={content.NEW_TEALIUM_INTEGRATION_CONTENT.help_text.tealium_profile}
                />
                <FormikInput
                  type="text"
                  id="tealium_user"
                  name="tealium_user"
                  label={content.NEW_TEALIUM_INTEGRATION_CONTENT.formLabels.tealium_user}
                  helperText={content.NEW_TEALIUM_INTEGRATION_CONTENT.help_text.tealium_user}
                />
                <div className="pt-2">
                  <Button type="submit" variant="primary" className="w-full md:w-auto">
                    {content.NEW_TEALIUM_INTEGRATION_CONTENT.submit_cta}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
      </div>
    </div>
  )
}

export default NewTealiumIntegration;